/**
 * Reducer to manage overpanels (when to show/hide them)
 */

import { ActionTypes as types } from '../constants'

const initialState = {
  addShippingAddress: false,
  addShippingAddressOverpanelKey: 'addShippingAddressOverpanelKey',
  addBillingAddress: false,
  addBillingAddressOverpanelKey: 'addBillingAddressOverpanelKey',
  addCard: false,
  addCardOverpanelKey: 'addCardOverpanelKey',
  currencyConversion: false,
  currencyConversionKey: 'currencyConversionKey',
  fundingOptionsOverpanelKey: 'fundingOptionsOverpanel',
  fundingOptionsOverpanel: false,
  error: false,
  openOverpanelCount: 0,
  threeDSecure: false,
  threeDSecureOverpanelKey: 'threeDSecureOverpanelKey',
  sendingLimit: false,
  sendingLimitOverpanelKey: 'sendingLimitOverpanelKey',
  paymentTypeChoice: false,
  contactDetails: false,
  showCashAdvanceFeesOverpanel: false,
  showGenericAboutCashAdvanceFeesOverpanel: false,
  showRiskHoldsOverpanel: false,
  showUserDCOverpanel: false,
  hasConfirmedRiskHolds: false,
  showThreeDS2ChallengeIframe: false,
  show3DS2SpinnerOverpanel: false,
  unilateralRecipientChoice: false,
  shouldShowSearchConsent: false,
  hasShownSearchConsent: false,
  isPreFlow: false,
  showOpenBankingOverpanel: false,
  shouldShowConfirmIdentityOverpanel: false,
  shouldShowPhotoUpload: false,
  ppme_slug: '',
  uploadedPhotoURL: '',
  blockContact: false,
  blockedContacts: false,
  contactBlocked: false,
  contactUnblocked: false,
  chatBlockContact: false,
  purchaseToPersonalTransactionPanelVisibility: false,
  showScamWarningOverpanel: false,
  scamResolvers: {
    resolve: () => {},
    reject: () => {},
  },
  showPurposeOfTransactionOverlay: false,
  purposeOfPaymentPayload: {},
  showCurrencyReceiverMismatchOverpanel: false,
  showCrossSellAdOverpanel: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.OVERPANELS.TOGGLE_THREEDS2_CHALLENGE_OVERPANEL:
      return {
        ...state,
        showThreeDS2ChallengeIframe: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_THREEDS2_SPINNER_OVERPANEL:
      return {
        ...state,
        show3DS2SpinnerOverpanel: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_ADD_SHIPPING_ADDRESS_OVERPANEL:
      return {
        ...state,
        addShippingAddress: action.data.show,
        addShippingAddressOverpanelKey: action.data.newOverpanelKey,
      }

    case types.OVERPANELS.TOGGLE_CURRENCY_CONVERSION_OVERPANEL:
      return {
        ...state,
        currencyConversion: action.data.show,
        currencyConversionKey: action.data.newOverpanelKey,
      }

    case types.OVERPANELS.TOGGLE_3D_SECURE_OVERPANEL:
      return {
        ...state,
        threeDSecure: action.data.show,
        threeDSecureOverpanelKey: action.data.newOverpanelKey,
      }

    case types.OVERPANELS.TOGGLE_CONFIRM_IDENTITY_OVERPANEL:
      return {
        ...state,
        shouldShowConfirmIdentityOverpanel: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_SENDING_LIMIT_OVERPANEL:
      return {
        ...state,
        sendingLimit: action.data.show,
        sendingLimitOverpanelKey: action.data.newOverpanelKey,
      }

    case types.OVERPANELS.TOGGLE_FUNDING_OPTIONS_OVERPANEL:
      return {
        ...state,
        fundingOptionsOverpanel: action.data.show,
        fundingOptionsOverpanelKey: action.data.newOverpanelKey,
      }

    case types.OVERPANELS.TOGGLE_PAYMENT_TYPE_CHOICE_OVERPANEL:
      return {
        ...state,
        paymentTypeChoice: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_UNILATERAL_RECIPIENT_CHOICE_OVERPANEL:
      return {
        ...state,
        unilateralRecipientChoice: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_CONTACT_DETAILS_OVERPANEL:
      return {
        ...state,
        contactDetails: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_SEARCH_CONSENT_OVERPANEL:
      return {
        ...state,
        shouldShowSearchConsent: action.data.show,
        isPreFlow: action.data.isPreFlow,
      }

    case types.OVERPANELS.TOGGLE_PHOTO_UPLOAD_OVERPANEL:
      return {
        ...state,
        shouldShowPhotoUpload: action.data.show,
        ppme_slug: action.data.ppme_slug,
      }

    case types.OVERPANELS.UPDATE_UPLOADED_PHOTO_URL:
      return {
        ...state,
        uploadedPhotoURL: action.data.uploadedPhotoURL,
      }

    case types.OVERPANELS.UPDATE_HAS_SHOWN_SEARCH_CONSENT_OVERPANEL:
      return {
        ...state,
        hasShownSearchConsent: action.data.hasShown,
      }

    case types.OVERPANELS.TOGGLE_ERROR_OVERPANEL:
      return {
        ...state,
        error: action.data.show,
      }

    case types.OVERPANELS.ADD_OPEN_OVERPANEL:
      return {
        ...state,
        openOverpanelCount: state.openOverpanelCount + 1,
      }

    case types.OVERPANELS.SUBTRACT_CLOSED_OVERPANEL:
      return {
        ...state,
        openOverpanelCount: state.openOverpanelCount - 1,
      }

    case types.ROUTER.LOCATION_CHANGE:
      return {
        ...initialState,
        // on route changes things get reset...
        // this is important so that overpanels can subtract themselves when they're done animating out (otherwise we end up below zero)
        openOverpanelCount: state.openOverpanelCount,
        hasShownSearchConsent: state.hasShownSearchConsent,
      }

    /* START Cash Advance Fee Specifics */
    case types.OVERPANELS.TOGGLE_CASH_ADVANCE_FEES_DISCLOSURE_OVERPANEL:
      return {
        ...state,
        showCashAdvanceFeesOverpanel: action.data.show,
        cashAdvanceFeesOverpanelContentType: action.data.type,
        currentSelectedFundingOption: action.data.selectedFundingOption,
      }
    case types.OVERPANELS.TOGGLE_CASH_ADVANCE_FEES_ABOUT_OVERPANEL:
      return {
        ...state,
        showGenericAboutCashAdvanceFeesOverpanel: action.data.show,
        cashAdvanceFeesOverpanelContentType: action.data.type,
        currentSelectedFundingOption: action.data.selectedFundingOption,
      }
    /* END Cash Advance Fee Specifics */

    /* START Risk Holds Specifics */
    case types.OVERPANELS.TOGGLE_RISK_HOLDS_OVERPANEL:
      return {
        ...state,
        showRiskHoldsOverpanel: action.data.show,
      }

    case types.OVERPANELS.CONFIRMED_RISK_HOLDS:
      return {
        ...state,
        hasConfirmedRiskHolds: true,
      }
    /* END Risk Holds Specifics */

    case types.OVERPANELS.TOGGLE_OPEN_BANKING_OVERPANEL:
      return {
        ...state,
        showOpenBankingOverpanel: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_USER_DC_OVERPANEL:
      return {
        ...state,
        showUserDCOverpanel: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_BLOCK_CONTACT_OVERPANEL:
      return {
        ...state,
        blockContact: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_BLOCKED_CONTACTS_OVERPANEL:
      return {
        ...state,
        blockedContacts: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_CONTACT_BLOCKED_OVERPANEL:
      return {
        ...state,
        contactBlocked: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_CONTACT_UNBLOCKED_OVERPANEL:
      return {
        ...state,
        contactUnblocked: action.data.show,
      }

    case types.OVERPANELS.TOGGLE_CHAT_BLOCK_CONTACT_OVERPANEL:
      return {
        ...state,
        chatBlockContact: action.data.show,
      }

    case types.OVERPANELS.PURCHASE_TO_PERSONAL_TRANSACTION_OVERPANEL:
      return {
        ...state,
        purchaseToPersonalTransactionPanelVisibility:
          action.data.purchaseToPersonalTransactionPanelVisibility,
      }

    case types.OVERPANELS.TOGGLE_SCAM_WARNING_OVERPANEL:
      return {
        ...state,
        showScamWarningOverpanel: action.data.show,
      }

    case types.OVERPANELS.SET_SCAM_RESOLVERS:
      return {
        ...state,
        scamResolvers: action.data.scamResolvers,
      }

    case types.OVERPANELS.SET_SCAM_WARNING_TYPE:
      return {
        ...state,
        scamWarningType: action.data.scamWarningType,
      }

    case types.OVERPANELS.TOGGLE_PURPOSE_OF_CODE_OVERPANEL:
      return {
        ...state,
        showPurposeOfTransactionOverlay: action.data.show,
        purposeOfPaymentPayload: action.data.purposeOfPaymentPayload,
      }
    case types.OVERPANELS.TOGGLE_CURRENCY_RECEIVER_MISMATCH_OVERPANEL:
      return {
        ...state,
        showCurrencyReceiverMismatchOverpanel: action.data.show,
      }
    case types.OVERPANELS.TOGGLE_CROSS_SELL_AD_OVERPANEL:
      return {
        ...state,
        showCrossSellAdOverpanel: action.data.show,
      }
    case types.OVERPANELS.TOGGLE_SEND_INTERNATIONAL_OVERPANEL:
      return {
        ...state,
        showInternationalCurrencySelector: action.data.show,
      }
    case types.OVERPANELS.TOGGLE_CURRENCY_REQUEST_CONFIRMATION_OVERPANEL:
      return {
        ...state,
        showCurrencyRequestConfirmationSelector: action.data.show,
      }
    default:
      return state
  }
}
